import React, {useEffect, useState} from 'react';
import styled from 'styled-components/macro';
import { fetchFile } from 'state/application/actions';
import { get } from 'lodash';
import ImageGalleryImageCache, { setImageCache } from './ImageGalleryImageCache';

function generateHeight(props, size) {
  return props.fullScreen ? '50vh' : props.thumbnail ? '100%' : size;
}

function generateWidth(props, size) {
  return props.fullScreen ? '70vw' : props.thumbnail ? '100%' : size;
}

const ExtraWrapperStyled = styled.p`
  width: auto;
  height: 100%;
  font-size: 90%;
  font-weight: bold;
  color: #ccc;
  text-align: center !important;
  line-height: 119%;
  background: #f3f3f3;
  display: flex;
  align-items: center;
  cursor: pointer;
  max-width: ${(props) => generateWidth(props, '270px')};
  max-height: ${(props) => generateHeight(props, '220px')};
  @media (min-width: 450px) {
    max-width: ${(props) => generateWidth(props, '400px')};
    max-height: ${(props) => generateHeight(props, '320px')};
  }
  @media (min-width: 600px) {
    max-width: ${(props) => generateWidth(props, '540px')};
    max-height: ${(props) => generateHeight(props, '420px')};
  }
  @media (min-width: 900px) {
    max-width: ${(props) => generateWidth(props, '231px')};
    max-height: ${(props) => generateHeight(props, '176px')};
  }

  @media (min-width: 1120px) {
    max-width: ${(props) => generateWidth(props, '380px')};
    max-height: ${(props) => generateHeight(props, '323px')};
  }
`;


const ImageWrapperStyled = styled.img`
  width: auto;
  height: auto;
  max-width: ${(props) => generateWidth(props, '270px')};
  max-height: ${(props) => generateHeight(props, '220px')};

  @media (min-width: 450px) {
    max-width: ${(props) => generateWidth(props, '400px')};
    max-height: ${(props) => generateHeight(props, '320px')};
  }
  @media (min-width: 600px) {
    max-width: ${(props) => generateWidth(props, '540px')};
    max-height: ${(props) => generateHeight(props, '420px')};
  }
  @media (min-width: 900px) {
    max-width: ${(props) => generateWidth(props, '231px')};
    max-height: ${(props) => generateHeight(props, '176px')};
  }
  @media (min-width: 1120px) {
    max-width: ${(props) => generateWidth(props, '380px')};
    max-height: ${(props) => generateHeight(props, '323px')};
  }
`;

export const ImageWrapperStyledBackground = styled.div`
  background-image: url("${(props) => props.image}");
  background-size: cover;
  height: 100%;
  width: 100%;
  background-position: center;
`;



const ImageWrapperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => props.thumbnail || props.pointer ? 'pointer' : 'auto'};
  margin: 0 auto;


  width: ${(props) => generateWidth(props, '270px')};
  height: ${(props) => generateHeight(props, '220px')};
  @media (min-width: 450px) {
    width: ${(props) => generateWidth(props, '400px')};
    height: ${(props) => generateHeight(props, '320px')};
  }
  @media (min-width: 600px) {
    width: ${(props) => generateWidth(props, '540px')};
    height: ${(props) => generateHeight(props, '420px')};
  }
  @media (min-width: 900px) {
    width: ${(props) => generateWidth(props, '231px')};
    height: ${(props) => generateHeight(props, '176px')};
  }
  @media (min-width: 1120px) {
    width: ${(props) => generateWidth(props, '380px')};
    height: ${(props) => generateHeight(props, '323px')};
  }
`;


const X = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;  
  p {
    text-align: center;
  
    font-size: 20px;
    color: #adadad;
    padding: 10px;
    font-weight: 500;
    border-radius: 4px;
  }
`;
 
const ImageGalleryImage = ({onClick, image, large, thumbnail, fullScreen, pointer, backgroundImage}) => {
  const hasImage = get(image, 'image');
  const finalImage = hasImage;
  const extra = image && image.extra;

  return (
    !hasImage && !extra ?
    <ImageWrapperContainer className="image-gallery-image-container" style={{position: 'relative'}}>
      <ImageWrapperStyled style={{opacity: 0.4, position: 'relative', zIndex: 2}} fullScreen={fullScreen} thumbnail={thumbnail} large={large} onClick={onClick} src="/images/logo-grey-pipe.svg" />
      <X><p>No Image</p></X>
    </ImageWrapperContainer> :
    finalImage || extra ?
    <ImageWrapperContainer className="image-gallery-image-container" pointer={pointer} fullScreen={fullScreen} thumbnail={thumbnail} large={large}>
      {
        extra ?
        <ExtraWrapperStyled>+{extra} more</ExtraWrapperStyled> :
        backgroundImage ?
        <ImageWrapperStyledBackground className="image-gallery-image-bkg" image={finalImage} /> :
        <ImageWrapperStyled className="image-gallery-image" alt={(image && image.original_file_name) || ''} fullScreen={fullScreen} thumbnail={thumbnail} large={large} onClick={onClick} src={finalImage} /> 

      }
    </ImageWrapperContainer> : <div></div>
  )
}


export default ImageGalleryImage
